// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Search {
    flex: 1 1 auto;
    display: inline-flex;
    position: relative;
    align-items: center;
    vertical-align: middle;
    max-width: 70ch;
    z-index: 4;
    color: var(--text-color);
}

#Search div.searchbar-wrapper {
    position: relative;
    display: inline-block;
    flex: 1 1 auto;
    height: 2.5em;
}

#Search div.searchbar-container {
    width: 100%;
    display: inline-flex;
}

#Search input.searchbar {
    flex: 1 1 auto;
    height: 2.5em;
    width: 0;
    min-width: 10ch;
}

#Search span.searchbar-addon {
    flex: 0 0 auto;
    height: 2.5em;
    width: 2.5em;
    background-color: var(--button-bg-color);
    color: var(--button-text-color);
    border-top: 1px solid var(--border-color);
    border-right: 1px solid var(--border-color);
    border-bottom: 1px solid var(--border-color);
    position: relative;
    align-items: center;
    display: flex;
    justify-content: center;
}

#Search span.searchbar-addon-active {
    background-color: var(--button-bg-color-hover);
    color: var(--button-text-color-hover);
}

#Search span.searchbar-addon-filter-active {
    background-color: var(--button-bg-color-active);
    color: var(--button-text-color-active);
}

#Search span.searchbar-addon-menu-icon {
    position: absolute;
    right: 0.125em;
    bottom: 0.125em;
    font-size: 70%;
    color: var(--text-color);
}

#Search ul.searchbar-provider-selection {
    position: absolute;
    top: 100%;
    right: -1px;
    background-color: var(--list-bg-color);
    border: 1px solid var(--border-color);
    list-style-type: none;
    margin: 0;
    padding: 0;
    color: var(--text-color);
}

#Search ul.searchbar-provider-selection li {
    padding: 0.5em;
    white-space: nowrap;
}

#Search li.searchbar-provider-selection-all {
    border-bottom: 1px solid var(--border-color);
}

#Search li.searchbar-provider-selection-active {
    background-color: var(--list-item-bg-color-active);
    color: var(--list-item-text-color-active);
}

#Search ul.searchbar-provider-selection li:hover {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

#Search div.spinner {
    width: 2em;
    height: 2em;
    margin: 0.25em;
}

#Search div.search-form {
    top: 0;
    width: 100%;
    position: absolute;
    z-index: 100;
    background-color: var(--button-bg-color);
    border: 1px solid var(--border-color);
}

#Search div.search-form > table {
    width: 100%;
}

#Search div.search-form > table td {
    padding: 0.125em 0.25em;
}

#Search div.search-form > table input {
    width: 100%;
    min-width: 0;
    max-width: none;
}

#Search div.search-form div.search-form-buttons {
    text-align: right;
    padding: 0.5em 0.25em;
}

#Search div.search-form div.search-form-buttons > button {
    padding: 0.25em;
    margin-left: 0.25em;
}

#Search ul.search-results {
    top: 100%;
    position: absolute;
    background-color: var(--list-bg-color);
    max-height: calc(100vh - var(--topbar-height) - var(--bottombar-height));
    max-height: calc(var(--vh, 1vh) * 100 - var(--topbar-height) - var(--bottombar-height));
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0;
    list-style-type: none;
    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);
    font-size: small;
}

#Search ul.search-results ul {
    list-style-type: none;
    padding: 0;
}

#Search ul.search-results ul li {
    padding: 0.25em 0.25em 0.25em 1em;
    display: flex;
    align-items: center;
    cursor: pointer;
}

#Search ul.search-results li.search-results-noresults {
    padding: 0.25em 0.25em 0.25em 1em;
    font-style: italic;
    color: var(--text-color-disabled);
}

#Search ul.search-results ul li > img {
    flex: 0 0 6em;
    width: 6em;
    height: auto;
    border: 1px solid var(--border-color);
    background-color: white;
    border-radius: 0.5em;
    margin-right: 1em;
}

#Search ul.search-results ul li > span {
    flex: 1 1 auto;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

#Search ul.search-results ul li > span.icon {
    flex: 0 0 auto;
    border: 1px solid var(--border-color);
    background-color: white;
    padding: 0.25em;
    border-radius: 0.25em;
}

#Search ul.search-results ul li > span.icon:hover {
    border-color: var(--color-active);
}

#Search ul.search-results ul li:hover {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

#Search ul.search-results .search-results-category-title {
    background-color: var(--list-section-bg-color);
    color: var(--list-section-text-color);
    font-weight: bold;
    display: block;
    padding: 0.5em;
}
`, "",{"version":3,"sources":["webpack://./qwc2/components/style/Search.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,YAAY;IACZ,wCAAwC;IACxC,+BAA+B;IAC/B,yCAAyC;IACzC,2CAA2C;IAC3C,4CAA4C;IAC5C,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,sCAAsC;IACtC,qCAAqC;IACrC,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,UAAU;IACV,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,MAAM;IACN,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,qCAAqC;AACzC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,sCAAsC;IACtC,wEAAwE;IACxE,uFAAuF;IACvF,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,UAAU;IACV,YAAY;IACZ,qCAAqC;IACrC,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qCAAqC;IACrC,uBAAuB;IACvB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,8CAA8C;IAC9C,qCAAqC;IACrC,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB","sourcesContent":["#Search {\r\n    flex: 1 1 auto;\r\n    display: inline-flex;\r\n    position: relative;\r\n    align-items: center;\r\n    vertical-align: middle;\r\n    max-width: 70ch;\r\n    z-index: 4;\r\n    color: var(--text-color);\r\n}\r\n\r\n#Search div.searchbar-wrapper {\r\n    position: relative;\r\n    display: inline-block;\r\n    flex: 1 1 auto;\r\n    height: 2.5em;\r\n}\r\n\r\n#Search div.searchbar-container {\r\n    width: 100%;\r\n    display: inline-flex;\r\n}\r\n\r\n#Search input.searchbar {\r\n    flex: 1 1 auto;\r\n    height: 2.5em;\r\n    width: 0;\r\n    min-width: 10ch;\r\n}\r\n\r\n#Search span.searchbar-addon {\r\n    flex: 0 0 auto;\r\n    height: 2.5em;\r\n    width: 2.5em;\r\n    background-color: var(--button-bg-color);\r\n    color: var(--button-text-color);\r\n    border-top: 1px solid var(--border-color);\r\n    border-right: 1px solid var(--border-color);\r\n    border-bottom: 1px solid var(--border-color);\r\n    position: relative;\r\n    align-items: center;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n#Search span.searchbar-addon-active {\r\n    background-color: var(--button-bg-color-hover);\r\n    color: var(--button-text-color-hover);\r\n}\r\n\r\n#Search span.searchbar-addon-filter-active {\r\n    background-color: var(--button-bg-color-active);\r\n    color: var(--button-text-color-active);\r\n}\r\n\r\n#Search span.searchbar-addon-menu-icon {\r\n    position: absolute;\r\n    right: 0.125em;\r\n    bottom: 0.125em;\r\n    font-size: 70%;\r\n    color: var(--text-color);\r\n}\r\n\r\n#Search ul.searchbar-provider-selection {\r\n    position: absolute;\r\n    top: 100%;\r\n    right: -1px;\r\n    background-color: var(--list-bg-color);\r\n    border: 1px solid var(--border-color);\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    color: var(--text-color);\r\n}\r\n\r\n#Search ul.searchbar-provider-selection li {\r\n    padding: 0.5em;\r\n    white-space: nowrap;\r\n}\r\n\r\n#Search li.searchbar-provider-selection-all {\r\n    border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n#Search li.searchbar-provider-selection-active {\r\n    background-color: var(--list-item-bg-color-active);\r\n    color: var(--list-item-text-color-active);\r\n}\r\n\r\n#Search ul.searchbar-provider-selection li:hover {\r\n    background-color: var(--list-item-bg-color-hover);\r\n    color: var(--list-item-text-color-hover);\r\n}\r\n\r\n#Search div.spinner {\r\n    width: 2em;\r\n    height: 2em;\r\n    margin: 0.25em;\r\n}\r\n\r\n#Search div.search-form {\r\n    top: 0;\r\n    width: 100%;\r\n    position: absolute;\r\n    z-index: 100;\r\n    background-color: var(--button-bg-color);\r\n    border: 1px solid var(--border-color);\r\n}\r\n\r\n#Search div.search-form > table {\r\n    width: 100%;\r\n}\r\n\r\n#Search div.search-form > table td {\r\n    padding: 0.125em 0.25em;\r\n}\r\n\r\n#Search div.search-form > table input {\r\n    width: 100%;\r\n    min-width: 0;\r\n    max-width: none;\r\n}\r\n\r\n#Search div.search-form div.search-form-buttons {\r\n    text-align: right;\r\n    padding: 0.5em 0.25em;\r\n}\r\n\r\n#Search div.search-form div.search-form-buttons > button {\r\n    padding: 0.25em;\r\n    margin-left: 0.25em;\r\n}\r\n\r\n#Search ul.search-results {\r\n    top: 100%;\r\n    position: absolute;\r\n    background-color: var(--list-bg-color);\r\n    max-height: calc(100vh - var(--topbar-height) - var(--bottombar-height));\r\n    max-height: calc(var(--vh, 1vh) * 100 - var(--topbar-height) - var(--bottombar-height));\r\n    width: 100%;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    padding: 0;\r\n    list-style-type: none;\r\n    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);\r\n    font-size: small;\r\n}\r\n\r\n#Search ul.search-results ul {\r\n    list-style-type: none;\r\n    padding: 0;\r\n}\r\n\r\n#Search ul.search-results ul li {\r\n    padding: 0.25em 0.25em 0.25em 1em;\r\n    display: flex;\r\n    align-items: center;\r\n    cursor: pointer;\r\n}\r\n\r\n#Search ul.search-results li.search-results-noresults {\r\n    padding: 0.25em 0.25em 0.25em 1em;\r\n    font-style: italic;\r\n    color: var(--text-color-disabled);\r\n}\r\n\r\n#Search ul.search-results ul li > img {\r\n    flex: 0 0 6em;\r\n    width: 6em;\r\n    height: auto;\r\n    border: 1px solid var(--border-color);\r\n    background-color: white;\r\n    border-radius: 0.5em;\r\n    margin-right: 1em;\r\n}\r\n\r\n#Search ul.search-results ul li > span {\r\n    flex: 1 1 auto;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n}\r\n\r\n#Search ul.search-results ul li > span.icon {\r\n    flex: 0 0 auto;\r\n    border: 1px solid var(--border-color);\r\n    background-color: white;\r\n    padding: 0.25em;\r\n    border-radius: 0.25em;\r\n}\r\n\r\n#Search ul.search-results ul li > span.icon:hover {\r\n    border-color: var(--color-active);\r\n}\r\n\r\n#Search ul.search-results ul li:hover {\r\n    background-color: var(--list-item-bg-color-hover);\r\n    color: var(--list-item-text-color-hover);\r\n}\r\n\r\n#Search ul.search-results .search-results-category-title {\r\n    background-color: var(--list-section-bg-color);\r\n    color: var(--list-section-text-color);\r\n    font-weight: bold;\r\n    display: block;\r\n    padding: 0.5em;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
